<template>
  <div class="wire vpc d-flex host">
    <span class="line" />
    <div :class="{'host-left-line': isLast}" />
    <div class="text-center">
      <tooltip v-if="tooltipShow">
        <template slot="title">
          {{ $t('cloudenv.text_101') }}
        </template>
        <template slot="content">
          <p>{{ $t('common.name') }}：{{ host.name }}</p>
          <p>{{ $t('system.cpu_count') }}：{{ host.cpu_count }}</p>
          <p>{{ $t('system.vcpu_count') }}：{{ host.vcpu_count }}</p>
          <p>{{ $t('system.mem_size') }}：{{ sizestr(host.mem_size, 'M', 1024) }}</p>
          <p>{{ $t('system.vmem_size') }}：{{ sizestr(host.vmem_size, 'M', 1024) }}</p>
          <p>{{ $t('cloudenv.text_72') }}：{{ (host.servers || []).length }}</p>
          <p>{{ $t('compute.passthrough_device_count') }}：{{ (host.isolate_devices || []).length }}</p>
          <p>{{ $t('system.gpu_used_count') }}：{{ (host.isolate_devices || []).filter(item => item.guest_id).length }}</p>
        </template>
      </tooltip>
      <icon type="res-host" @click="handleClick" @mouseover="handleMouseover" @mouseout="handleMouseout" />
      <span class="name text-truncate" style="overflow: visible;"><div class="text">{{ host.name }}</div></span>
      <icon v-if="(host.servers.length || host.isolate_devices.length) && !host.isChildrenShow" class="expand-icon" @click="handleClick" type="expand" />
    </div>
    <span class="line" :style="showRightLine ? '' : 'border:none'" />
  </div>
</template>

<script>
import ResMixin from '@Network/sections/Topology/ResMixin'
import { sizestr } from '@/utils/utils'
import Tooltip from './Tooltip'

export default {
  name: 'ResHost',
  components: {
    Tooltip,
  },
  mixins: [ResMixin],
  props: {
    dataSource: {
      type: Object,
      default () {
        return {}
      },
    },
    host: {
      type: Object,
      default () {
        return {}
      },
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    hostVisible: Boolean,
  },
  data () {
    return {
      sizestr,
      tooltipShow: false,
    }
  },
  computed: {
    showRightLine () {
      if (this.host.servers && this.host.servers.length && this.host.isChildrenShow) return true
      if (this.host.isolate_devices && this.host.isolate_devices.length && this.host.isChildrenShow) return true
      return false
    },
  },
  methods: {
    handleClick (e) {
      this.$emit('click')
    },
    handleMouseover () {
      this.tooltipShow = true
    },
    handleMouseout () {
      this.tooltipShow = false
    },
  },
}
</script>

<style lang="scss" scoped>
// @import "@Network/sections/Topology/index.scss";
.wire {
  min-height: 120px!important;
  width: 150px !important;
  .vpc {
    min-height: 120px!important;
    .line {
      width: 200px !important;
    }
  }
}
.host {
  position: relative;
  .host-left-line {
    width: 10px;
    height: 120px;
    position: absolute;
    left: -5px;
    top: 2px;
    background: #ffffff;
  }
}
.expand-icon {
  position: absolute;
  left: 85px;
  top: 38px;
  width: 15px!important;
  height: 15px!important;
  border: none!important;
}
</style>
